import type { ScreeningPresentation, SectionConfig } from '../../config';
import { FieldsRenderer } from '../../fields-renderer';
import { SectionShell } from '../section-shell';

export type ScreeningSectionProps = {
  config: SectionConfig & ScreeningPresentation;
};

// Intentionally minimal. Specialized institutional/SMB chrome
// (`NestedCoverageSelect`, `CustomizeCoverageButton`, SMB pricing) stays in
// the consumers and plugs in via `section.slots.afterFields` during P3.x —
// keeps the engine free of consumer-specific coupling like `useDealsDashboard`.
export const ScreeningSection = ({ config }: ScreeningSectionProps) => {
  const defaultTitle =
    config.title ?? (config.variant === 'smb' ? 'Select coverage' : 'Screening result');

  return (
    <SectionShell
      title={defaultTitle}
      subtitle={config.subtitle}
      slots={config.slots}
      spacing={config.spacing}
    >
      <FieldsRenderer fields={config.fields} sectionKey="screening" />
    </SectionShell>
  );
};
